<template>
  <div class="hello page-import">
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务</el-breadcrumb-item>
          <el-breadcrumb-item>财务数据源</el-breadcrumb-item>
          <el-breadcrumb-item>导入记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="importRecordTable">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="财务数据源" name="XZ_emp_FnncDataSource"></el-tab-pane>
          <!-- <el-tab-pane label="项目收支表社保" name="XZ_emp_FnncSocialInsu"></el-tab-pane>
          <el-tab-pane label="工资清单" name="XZ_emp_Fnnc"></el-tab-pane>
          <el-tab-pane label="项目收支表费用" name="XZ_emp_FnncProCost"></el-tab-pane>
          <el-tab-pane label="利润表" name="XZ_emp_FnncProfit"></el-tab-pane>
          <el-tab-pane label="项目开票信息表" name="XZ_emp_FnncProjectInvoice"></el-tab-pane> -->
        </el-tabs>
        <el-table :data="tableData" :max-height="tableHeight-180" style="width: 99%" v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" width="50"></el-table-column> -->
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrServCentName" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrCustName" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="负责客服" prop="StrServUsrName" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="记账月份" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.BookMonth}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="归属月份" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.AttributionMonth}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作时间" prop="opTime" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" label="导入进度" width="250px">
            <template slot-scope="scope">
              <div>
                <el-steps :active="scope.row.StrImpEdateStr * 0.05" :process-status="(scope.row.StrImpEdateStr == '100') ? 'success' : 'error' " align-center :space="50">
                  <el-step title="解析"
                    :status="(scope.row.StrImpEdateStr=='20' || scope.row.StrImpEdateStr=='40' || scope.row.StrImpEdateStr=='60'|| scope.row.StrImpEdateStr=='80'|| scope.row.StrImpEdateStr=='100') ? 'success' : ((new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime())  ||  (scope.row.StrImpEdateStr!='0'&&scope.row.StrImpEdateStr!='20'&&scope.row.StrImpEdateStr!='40'&&scope.row.StrImpEdateStr!='60'&&scope.row.StrImpEdateStr!='80'&&scope.row.StrImpEdateStr!='100'&&scope.row.StrImpEdateStr!=null) ? 'error' : 'wait') ">
                  </el-step>
                  <el-step title="导入"
                    :status="(scope.row.StrImpEdateStr=='40' || scope.row.StrImpEdateStr=='60'|| scope.row.StrImpEdateStr=='80'|| scope.row.StrImpEdateStr=='100') ? 'success' : ((new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime())  ||  (scope.row.StrImpEdateStr!='0'&&scope.row.StrImpEdateStr!='20'&&scope.row.StrImpEdateStr!='40'&&scope.row.StrImpEdateStr!='60'&&scope.row.StrImpEdateStr!='80'&&scope.row.StrImpEdateStr!='100'&&scope.row.StrImpEdateStr!=null) ?'error' : 'wait') ">
                  </el-step>
                  <el-step title="勘误"
                    :status="(scope.row.StrImpEdateStr=='60'|| scope.row.StrImpEdateStr=='80'|| scope.row.StrImpEdateStr=='100') ? 'success' : ((new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime()) ||  (scope.row.StrImpEdateStr!='0'&&scope.row.StrImpEdateStr!='20'&&scope.row.StrImpEdateStr!='40'&&scope.row.StrImpEdateStr!='60'&&scope.row.StrImpEdateStr!='80'&&scope.row.StrImpEdateStr!='100'&&scope.row.StrImpEdateStr!=null) ? 'error' : 'wait') ">
                  </el-step>
                  <el-step title="入库"
                    :status="(scope.row.StrImpEdateStr=='80'|| scope.row.StrImpEdateStr=='100') ? 'success' : ((new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime()) ||  (scope.row.StrImpEdateStr!='0'&&scope.row.StrImpEdateStr!='20'&&scope.row.StrImpEdateStr!='40'&&scope.row.StrImpEdateStr!='60'&&scope.row.StrImpEdateStr!='80'&&scope.row.StrImpEdateStr!='100'&&scope.row.StrImpEdateStr!=null) ? 'error' : 'wait') ">
                  </el-step>
                  <el-step title="完成"
                    :status="scope.row.StrImpEdateStr=='100' ? 'success' : ((new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime()) ||  (scope.row.StrImpEdateStr!='0'&&scope.row.StrImpEdateStr!='20'&&scope.row.StrImpEdateStr!='40'&&scope.row.StrImpEdateStr!='60'&&scope.row.StrImpEdateStr!='80'&&scope.row.StrImpEdateStr!='100'&&scope.row.StrImpEdateStr!=null)? 'error' : 'wait') ">
                  </el-step>
                </el-steps>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="导入结果" min-width="140px">
            <template slot-scope="scope">
              <span v-show="(scope.row.StrImpEdateStr == '100')&& (Number(scope.row.ErrorNum) > 0)">导入成功 (有{{scope.row.ErrorNum}}个错误数据,可点击感叹号图片查看原因)</span>
              <span v-show="(scope.row.StrImpEdateStr == '100')&& isNull(scope.row.ErrorNum)">导入成功</span>
              <span
                v-show="((scope.row.StrImpEdateStr != '100')&&(new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime())) || (scope.row.StrImpEdateStr!='0' && scope.row.StrImpEdateStr!=null && scope.row.StrImpEdateStr!='20' && scope.row.StrImpEdateStr!='40' && scope.row.StrImpEdateStr!='60' && scope.row.StrImpEdateStr!='80' && scope.row.StrImpEdateStr!='100')">
                <span
                  style="color:#ff0000">{{(scope.row.StrImpEdateStr=='0' || scope.row.StrImpEdateStr=='20' ||scope.row.StrImpEdateStr=='40' || scope.row.StrImpEdateStr=='60'|| scope.row.StrImpEdateStr=='80'|| scope.row.StrImpEdateStr=='100' || scope.row.StrImpEdateStr== null) ? ( scope.row.StrImpEdateStr=='20'? '导入失败' : '导入失败,请核对导入数据是否正确') : '导入失败 ('+scope.row.StrImpEdateStr+')'}}</span>
                <!-- <span>{{scope.row.StrImpEdateStr=='20'? '导入失败，请核对花名册数据是否正确后再导入' : '导入失败,'+scope.row.StrImpEdateStr}}</span> -->
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="格式错误数量" prop="errorlength" min-width="100px">
            <template slot-scope="scope">
              <div v-show="(scope.row.StrImpEdateStr == '100')&& Number(scope.row.ErrorNum) > 0" @click="showErrorDetails(scope.row)" class="errorLi">
                <img src="../../assets/employee/images/warning.png" alt="" style="width: 24px" />
                <span style="margin-left: 10px">{{
                  scope.row.ErrorNum
                }}</span>
              </div>
              <div v-show="(scope.row.StrImpEdateStr == '100')&& isNull(scope.row.ErrorNum)">
                <img src="../../assets/employee/images/success.png" style="width: 24px">
              </div>
              <el-tooltip effect="dark"
                :content="(scope.row.StrImpEdateStr=='0' || scope.row.StrImpEdateStr=='20' ||scope.row.StrImpEdateStr=='40' || scope.row.StrImpEdateStr=='60'|| scope.row.StrImpEdateStr=='80'|| scope.row.StrImpEdateStr=='100' || scope.row.StrImpEdateStr== null) ? ( scope.row.StrImpEdateStr=='20'? '导入失败' : '导入失败，请核对花名册数据是否正确') : scope.row.StrImpEdateStr"
                placement="top">
                <div
                  v-show="((scope.row.StrImpEdateStr != '100')&&(new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime())) || (scope.row.StrImpEdateStr!='0' && scope.row.StrImpEdateStr!=null && scope.row.StrImpEdateStr!='20' && scope.row.StrImpEdateStr!='40' && scope.row.StrImpEdateStr!='60' && scope.row.StrImpEdateStr!='80' && scope.row.StrImpEdateStr!='100')">
                  <img src="../../assets/employee/images/error.png" style="width: 24px">
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="210px">
            <template slot-scope="scope">
              <button class="changeServe" @click="showDetails(scope.row)" v-if="(scope.row.StrImpEdateStr=='100') && isNull(scope.row.ErrorNum) && (scope.row.StrCustName != '财务数据源')">
                <span>查看详情</span>
              </button>
              <button class="changeError" @click="showErrorDetails(scope.row)" v-if="Number(scope.row.ErrorNum) > 0 && (scope.row.StrImpEdateStr == '100') && (scope.row.StrCustName != '财务数据源')">修改错误</button>
              <!-- <button class="changeState"
                v-if="(new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime())&&(scope.row.StrImpEdateStr!='100')|| (scope.row.StrImpEdateStr!='0' && scope.row.StrImpEdateStr!=null && scope.row.StrImpEdateStr!='20' && scope.row.StrImpEdateStr!='40' && scope.row.StrImpEdateStr!='60' && scope.row.StrImpEdateStr!='80' && scope.row.StrImpEdateStr!='100')"
                @click="queryImportState(scope.row)">重新导入</button> -->
                <button class="changeServe"
                v-if="loginRoletype!='customer'&& (scope.row.StrCustName == '财务数据源') && (scope.row.StrImpEdateStr!='20')"
                @click="dtlHandle(scope.row)">数据源校验详情</button>
                <button class="changeState"
                v-if="loginRoletype!='customer'&& (new Date().getTime() > new Date((new Date(scope.row.opTime)).valueOf() + 360000).getTime())"
                @click="queryImportState(scope.row)">重新导入</button>
                <!-- <el-button v-if="loginRoletype!='customer'" class="pinkButton" :disabled="!scope.row.BookingRealMonth" @click="deleteHandle(scope.row.StrObjName,'XZ_emp_Fnnc')">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="totalnum > 0" style="width:99%">
          <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="infoQuery.currpage"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="infoQuery.pagecount"
          layout="total,sizes,prev,pager, next, jumper"
          :total="totalnum"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 勘误后导入 -->
    <div class="dialog">
      <el-dialog :visible.sync="dialogVisible5" width="700px">
        <div class="diaTitle">导入数据 至 {{exportName}}</div>
        <el-steps :active="active" finish-status="success" class="steps-box">
          <el-step title="基础信息"></el-step>
          <el-step title="上传导入文件"></el-step>
          <el-step title="导入处理"></el-step>
        </el-steps>
        <div v-if="active==0" style="margin-top:15px;padding-bottom:15px;">
          <div>
            <div class="impTitle">导入模板:</div>
            <div class="storageInput" style="margin:0 20px 0 0">
              <el-select v-model="tabName" slot="prepend" placeholder="请选择" disabled filterable @change="selectTab">
                <el-option v-for="(item, index) in this.tableList" :key="index" :label="item.StrTableName" :value="{value:item.StrTableId,label:item.StrTableName}"></el-option>
              </el-select>
            </div>
          </div>
          <div class="flex impdata">
            <div class="bookkeepingMonth" v-if="isBookmonthShow">
              <div class="impTitle">记账月份:</div>
              <el-date-picker v-model="bookDate" type="month" :picker-options="pickerOptions" placeholder="选择月" value-format="yyyy-MM"></el-date-picker>
            </div>
            <div class="bookkeepingMonth">
              <div class="impTitle">归属月份:</div>
              <el-date-picker v-model="belongMonth" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM"></el-date-picker>
            </div>
          </div>
        </div>
        <div v-if="active==1" style="margin-top:15px;padding-bottom:15px;">
          <div class="note-txt">
            <p style="font-weight:bold;">上传文件说明：</p>
            <p>1. 支持文件后缀 xls、xlsx文件。
            </p>
            <p>2. 请将要上传的内容放在第一个sheet中。
            </p>
            <p>3. 请不要加密模板文件，将导致错误。
            </p>
            <p>4. 请不要上传带宏的文件，将导致错误。
            </p>
            <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。
            </p>
            <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
          </div>
          <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
          <div class="form-item" style="justify-content: space-between;">
            <div class="file-box">
              <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn">上传</label>
            </div>
            <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载模板</el-button>
          </div>
          <!-- 提示 -->
          <p style="color:red;" v-if="isError">{{errorTxt}}</p>
          <div class="reimpArea">
            <div style="margin-top:10px">
              <!-- <el-checkbox v-model="isReset" @change="selectReimp">是否覆盖导入</el-checkbox> -->
              <!-- <el-radio v-model="reimpLab" label="0" border size="small" @change="selectReimp">否</el-radio>
                  <el-radio v-model="reimpLab" label="1" border size="small" @change="selectReimp">是</el-radio> -->
            </div>
          </div>
        </div>
        <div v-if="active==2" style="margin-top:15px;padding-bottom:15px;">
          <div class="result-box">
            <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;-webkit-justify-content:flex-end;padding-bottom: 30px;">
          <el-button size="small" @click="dialogVisible5 = false" v-if="active==0">取消</el-button>
          <el-button size="small" @click="prevSteps" v-if="active>0 && active<=1">上一步</el-button>
          <el-button type="primary" size="small" @click="nextSteps" v-if="(active<1 && impType!='社保') || (active<1&&impType=='社保'&&isimp==0)">下一步</el-button>
          <el-popconfirm style="margin-left:15px" confirm-button-text='删除旧数据重新导入' cancel-button-text='不删除旧数据，继续导入' icon="el-icon-info" icon-color="red" v-if="active<1 && (impType=='社保'&&isimp!=0)" title="该月份已经导入过数据，请问是否删除之前导入的数据重新导入？" @confirm="nextDel" @cancel="nextSteps">
            <el-button slot="reference" type="primary" size="small">下一步</el-button>
          </el-popconfirm>
          <el-tooltip effect="dark" content="未上传文件不能提交" :disabled="!isUploadSuccess" placement="top">
            <div style="display:inline-block;margin-left:10px">
              <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请等待..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-if="active==1" :disabled="isUploadSuccess">提交</el-button>
            </div>
          </el-tooltip>
          <el-button type="primary" size="small" @click="backHandle" v-if="active==2">确认并返回</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import xz from "../../common";
import FUN from "../../fun";
export default {
  name: "financialImport",
  data() {
    return {
      activeName:'XZ_emp_FnncDataSource',
      // 是否是财务数据源页面（判断记账月份是否显示）
      isBookmonthShow: true,
      //关账人员类型 1能关账
      closeAccountType:'',
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      //表头错误提示
      isError: false,
      errorTxt: '',
      min: 1,
      rowinfo: "",
      downloadDialog: false,
      listLoading: false,
      dialogVisible5: false,
      totalnum: null,
      //勘误后导入
      ExcelSrc: {
        value: "",
        check: false,
        fileName: "",
        oldexcelpath: ''
      },
      //导入到的项目名称
      exportName: '',
      //导入步骤
      active: 0,
      //是否覆盖
      isReset: false,
      //文件是否已上传
      isFileSuccess: false,
      errorColumn: [],
      excelpath: '',
      tableList: [],
      reimp: 0,
      reimpLab: "0",
      process: 0,
      infoPath: "",
      entid: "",
      instname: "",
      StrUserName: "",
      StrSrvCent: "",
      StrObjName: "",
      //下拉选择表格
      tabName: "财务数据源",
      tabId: "XZ_emp_FnncDataSource",
      fullscreenLoading: false,
      //已选择的下级
      selectedSubordinate: null,
      //下拉筛选
      showDropScreen: -1,
      tableData: [],
      //列表数据参数
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "XZ_emp_FnncDataSource",//XZ_emp_Fnnc//项目收支表客服 XZ_emp_FnncSocialInsu//项目收支表社保 XZ_emp_FnncProCost//项目收支表费用 //XZ_emp_FnncDataSource数据源
        instname: "",
        datestart: "",
        dateend: "",
        objname: "",
        strobjinstname: "",
        strusername: "",
        impdate: ''
      },
      //上传excel是否成功-判断下一步按钮是否禁用
      isUploadSuccess: true,
      // 定时器
      timer: null,
      //旧的excel地址
      oldexcelpath: '',
      strTableId: "",
      //归属日期
      belongMonth: "",
      //记账日期
      bookDate: "",
      //下载模板参数
      downloadQuery:{
        fileid:'财务数据源',
        tableid:'XZ_emp_FnncDataSource'
      },
      //关账日期
      closeDate:'',
      //禁用日期范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      //关账日期查询参数
      closeQuery:{
        currpage:1,
        perpage:10
      },
      //表格类型参数
      tabQuery:{
        pagecount: 1000,
        currpage: 1,
        tablename: "",
        ctluserid: "",
        strTableId:''
      },
      //人员角色
      loginRoletype:'',
      //是否导入过
      isimp: 0,
      //是哪种导入类型
      impType:'',
      //删除数据参数
      delQuery:{
        strObjName: '',
        tableid: '',
        bookingRealMonth: '',
        belongMonth: ''
      }
    };
  },
  created() {
    this.closeAccountType = localStorage.closeAccountType
    this.loginRoletype = localStorage.loginRoletype
    this.calHeight();
    this.getTabInfo();
    this.getOpeRecord(this.infoQuery);
    this.dataRefreh();
  },
  methods: {
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height', this.tableHeight)
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.infoQuery.tableid = tab.name
      this.infoQuery.currpage = 1
      this.getOpeRecord(this.infoQuery);
      this.dataRefreh();
    },
    // 数据源校验详情
    dtlHandle(item){
      this.$router.push({
        path: "/checkDetail",
        query: {
          strExcelPath: item.StrExcelPath,
          bookDate: item.BookMonth,
          belongMonth: item.AttributionMonth
        }
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
    },
    // 清除定时器的代码
    clear() {
      clearInterval(this.timer)
      this.timer = null
    },
    // 定时刷新数据函数
    async dataRefreh() {
      const thats = this
      // 计时器正在进行中，退出函数
      if (this.timer != null) {
        return;
      }
      // //如果返回的数据有一个不成功就刷新 反之清除定时器
      // 计时器为空，操作
      this.timer = setInterval(() => {
        // console.log("刷新" + new Date());
        this.min++;
        let errcount = 0;
        for (let index = 0; index < this.tableData.length; index++) {
          const elementData = this.tableData[index];
          let itemDate = elementData.StrImpBdateStr.substring(0, 4) + '-' + elementData.StrImpBdateStr.substring(4, 6) + '-' + elementData.StrImpBdateStr.substring(6, 8) + ' ' + elementData.StrImpBdateStr.substring(8, 10) + ':' + elementData.StrImpBdateStr.substring(10, 12) + ':' + elementData.StrImpBdateStr.substring(12, 14)
          if (new Date().getTime() < new Date((new Date(itemDate)).valueOf() + 360000)) {
            if (elementData.StrImpEdateStr == null || elementData.StrImpEdateStr != '100') {
              // console.log('pp', new Date((new Date(itemDate)).valueOf() + 360000))
              errcount = errcount + 1
            } else if (elementData.StrImpEdateStr != '100' && elementData.StrImpEdateStr.length < 5) {
              // console.log('pp', new Date((new Date(itemDate)).valueOf() + 360000))
              errcount = errcount + 1
            }
          }
        }
        // console.log('errcount',errcount)
        if (errcount > 0) {
          thats.getOpeRecord(thats.infoQuery);
        } else {
          clearInterval(this.timer);
        }
      }, 20000);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.infoQuery.currpage = Number(val);
      this.getOpeRecord(this.infoQuery);
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.infoQuery.currpage = 1
      this.infoQuery.pagecount = Number(val);
      this.getOpeRecord(this.infoQuery);
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    //导入的表格类型列表
    getTabInfo() {
      xz.getfinanceemptabledef(this.tabQuery).then(res => {
        // console.log("ddd", res);
        this.tableList = res.data;
      });
    },
    getOpeRecord(data) {
      this.infoQuery = data;
      this.listLoading = true
      xz.getfinanceimpdatalist(data).then(res => {
        this.totalnum = parseInt(res.totalnum);
        if (res.data && res.data.length > 0) {
          res.data.forEach(l => {
            var opTime = l.StrImpBdateStr.substring(0, 4) + "/" + l.StrImpBdateStr.substring(4, 6) + "/" + l.StrImpBdateStr.substring(6, 8) + " " + l.StrImpBdateStr.substring(8, 10) + ":" + l.StrImpBdateStr.substring(10, 12);
            l['opTime'] = opTime
            if (!this.isNull(l.StrErrorLine)) {
              let errorData = l.StrErrorLine.split('|')
              l['ErrorNum'] = errorData[0] //错误数量
              l['BookMonth'] = errorData[1] //记账月份
              l['AttributionMonth'] = errorData[2] //归属月份
            }
          })
          this.tableData = res.data
        } else {
          this.totalnum = 0
          this.tableData = []
        }
        this.listLoading = false
      })
    },
    //下一步导入
    async nextSteps() {
      if (this.active == 0) {
        if (this.tabName == '') {
          this.$message({
            message: "请选择导入模板",
            type: "warning"
          });
          this.active = 0
          return false
        }
        if(this.tabName == '利润表'||this.tabName == '项目开票信息表'){
          if (!this.bookDate) {
            this.$message.warning('请选择记账月份')
            return false
          }
        }else{
          // 判断是否是财务数据源的数据
          if(this.isBookmonthShow){
            if (!this.belongMonth || !this.bookDate) {
              this.$message.warning('请选择归属月份和记账月份')
              return false
            }
          }else{
            if (!this.belongMonth) {
              this.$message.warning('请选择归属月份')
              return false
            }
          }
          
        }
      }
      this.active += 1
    },
    //上一步导入
    prevSteps() {
      // this.selectMonth()
      // console.log('ds', this.isimp)
      this.active -= 1
    },
    //提交导入
    async lastSteps() {
      if (this.ExcelSrc.value == '') {
        this.isUploadSuccess = true
        this.$message({
          message: "请选择文件上传",
          type: "warning"
        });
        this.active = 1
        return false
      }
      else {
        //检查表头是否正确
        let checkData = {
          excelpath: this.excelpath,
          tableid: this.tabId,
          fileid: this.tabName
        }
        this.fullscreenLoading = true;
        xz.chkfinanceimpdatatbtype(checkData).then(res => {
          // console.log('checkData',res)
          let resultTxt = res
          if (this.isNull(res)) {
            this.isError = false
            this.isUploadSuccess = false
            const Edata = {
              instname: this.instname,
              tableid: this.tabId,
              reimp: this.reimp,
              excelpath: this.excelpath,
              impexcel: this.ExcelSrc.fileName,
              servusrname: this.StrUserName,
              servcentname: this.StrSrvCent,
              custname: this.StrObjName,
              fileid: this.tabName,
              bookingRealMonth: this.bookDate,
              belongMonth: this.belongMonth,
              oldexcelpath: this.oldexcelpath
            }
            xz.financeAnlysisExcelInf(Edata).then(res => {
              // console.log('Edata', res)
              if (res) {
                this.active = 2
              } else {
                this.$message('导入错误');
              }
              this.fullscreenLoading = false;
            })
          } else {
            this.isError = true
            this.active = 1
            this.isUploadSuccess = true
            this.errorTxt = resultTxt
            //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
            //清空input file值
            var file = document.getElementById("fileInput");
            file.value = "";
            this.fullscreenLoading = false;
          }
        })
      }
    },
    //导入-确认返回
    async backHandle() {
      this.dialogVisible5 = false
      this.infoQuery.currpage = 1
      this.getOpeRecord(this.infoQuery)
      this.dataRefreh();
    },
    //修改错误
    showErrorDetails(row) {
      // console.log('修改错误', row)
      let strexcelpath = row.StrExcelPath
      if (Number(row.ErrorNum) >= 0) {
        this.$router.push({
          path: "/financialError",
          query: {
            strexcelpath,
            custname: row.StrCustName,
            strTableId: row.StrTableId
          }
        })
      } else {
        this.$message({
          message: '数据未导入',
          type: "error"
        })
        return
      }
    },
    //下载模板
    downLoadHandle() {
      // console.log('下载模板',this.downloadQuery)
      xz.getfinanceinputmode(this.downloadQuery.fileid, 'output_' + this.downloadQuery.tableid).then(res => {
        // console.log('下载模板',res)
        if (res) {
          let d = res.msg.data.StrOutPath;
          let path = this.tablePath + d;
          // console.log('path',path)
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click()
          this.downloadDialog = false
        } else {
          this.$message.warning('下载模板错误，请稍后再试')
        }
      })
    },
    //文件读取
    importf() {
      const fileInput = this.$refs.upload;
      this.excelpath = ''
      FUN.returnExcelSrc(fileInput).then(src => {
        if (src) {
          console.log('src0o0', src)
          this.$set(this.ExcelSrc, "value", src.src);
          this.$set(this.ExcelSrc, "check", false);
          this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
          // console.log('srccc', this.ExcelSrc)
          //上传excel
          const excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
          const formData = new FormData();
          formData.append("pagename", 'empexcel');
          formData.append("action", 'save');
          formData.append("userid", Cookies.get("userid-b"));
          formData.append("entid", this.entid);
          formData.append("excel", excelFile, this.ExcelSrc.fileName);
          // console.log('formData', formData)
          xz.uploadCert(formData).then(res => {
            // console.log('res', res)
            // this.excelpath = res;
            if (this.isNull(res) || res == false) {
              this.$message('上传Excel失败!')
              this.isUploadSuccess = true
            } else {
              this.errorTxt = ''
              this.excelpath = res;
              localStorage.setItem('epath', res)
              this.isUploadSuccess = false
              this.$refs['upload'].value = null;
            }
          });
        } else {
          this.$message('上传Excel失败!')
        }
      })
    },
    // 下拉选择人员
    selectSubordinate(d) {
      this.userId = d.value;
      this.username = d.label;
      // console.log("d", d);
      this.selectedSubordinate = d.label;
    },
    // 下拉选择表格
    selectTab(d) {
      this.tabId = d.value;
      this.tabName = d.label;
      this.downloadQuery.tableid = d.value
      this.downloadQuery.fileid = d.label
      // console.log("dee", d);
    },
    // 下拉选择是否覆盖
    selectReimp(d) {
      if (d == true) {
        this.reimp = 1
        this.reimpLab = 1
      } else {
        this.reimp = 0
        this.reimpLab = 0
      }
      // console.log("d", d);
    },
    //查询导入状态
    queryImportState(val) {
      let data = this.infoQuery;
      console.log('fds', val, data)
      data.strsrvcent = val.StrServCentName;
      data.strobjname = val.StrCustName;
      if(val.StrCustName == '财务数据源'){
        this.isBookmonthShow = false
      }
      xz.getfinanceimpdatalist(data).then(res => {
        if (res) {
          if (res.data.length > 0) {
            let opTime = res.data[0].StrImpBdateStr.substring(0, 4) + "/" + res.data[0].StrImpBdateStr.substring(4, 6)
              + "/" + res.data[0].StrImpBdateStr.substring(6, 8) + " " + res.data[0].StrImpBdateStr.substring(8, 10)
              + ":" + res.data[0].StrImpBdateStr.substring(10, 12);
            if (new Date().getTime() > new Date((new Date(opTime)).valueOf() + 360000).getTime()) {
              this.reImportHandle(val)
            } else {
              if (res.data[0].StrImpEdateStr != null && res.data[0].StrImpEdateStr != '20' && res.data[0].StrImpEdateStr != '40' && res.data[0].StrImpEdateStr != '60' && res.data[0].StrImpEdateStr != '80') {
                this.reImportHandle(val)
              } else {
                this.$message({
                  message: '您有一条正在导入的记录，请在导入完成后再导入',
                  duration: 5000,
                  type: 'warning'
                })
              }
            }
          } else {
            this.reImportHandle(val)
          }
        } else {
          this.$message.error('系统出错，请联系管理员')
        }
      })
    },
    //重新导入前的删除
    nextDel() {
      this.fullscreenLoading = true;
      xz.delfnncuserimport(this.delQuery).then(res => {
        if (res) {
          this.$message.success("删除成功！");
          this.nextSteps();
          this.fullscreenLoading = false;
        } else {
          this.$message.fileid("删除失败！");
        }
      })
    },
    // selectMonth() {
    //   // console.log("date", date);
    //   if (this.impType == "社保" && this.bookDate && this.belongMonth) {
    //     const data = {
    //       bookingRealMonth: this.bookDate,
    //       belongMonth: this.belongMonth,
    //       tableid: this.delQuery.tableid
    //     }
    //     //判断社保是否已经导入过
    //     xz.isfinanceImpDataInsu(data).then(res => {
    //       if (res) {
    //         this.isimp = res.totalnum;
    //         // console.log('ds', res.totalnum)
    //       }
    //     })
    //   }
    // },
    //勘误后导入
    async reImportHandle(row) {
      this.active = 0
      // this.tabName = ''
      this.ExcelSrc = {
        value: "",
        check: false,
        fileName: ""
      }
      let delDate = row.StrErrorLine.split('|')
      this.delQuery = {
        strObjName: row.StrCustName,
        tableid:  row.StrTableId,
        bookingRealMonth: delDate[1],
        belongMonth: delDate[2]
      }
      this.bookDate = delDate[1]
      this.belongMonth = delDate[2]
      if(row.StrTableId == 'XZ_emp_FnncProCost'){
        this.impType = '费用'
      }else if(row.StrTableId == 'XZ_emp_Fnnc'){
        this.impType = '客服'
      }else if(row.StrTableId == 'XZ_emp_FnncSocialInsu'){
        this.impType = '社保'
      }else if(row.StrTableId == 'XZ_emp_FnncProfit'){
        this.impType = '利润'
      }else if(row.StrTableId == 'XZ_emp_FnncProjectInvoice'){
        this.impType = '开票信息'
      }
      // //判断社保是否已经导入过
      // this.selectMonth()
      this.tabQuery.strTableId = row.StrTableId
      this.errorTxt = ''
      this.closeHandle()
      this.getTabInfo()
      this.dialogVisible5 = true;
      this.exportName = row.StrCustName
      this.oldexcelpath = row.StrExcelPath
      // console.log('info', row)
      this.infoPath = '雇员花名册>' + row.StrServCentName + '>' + row.StrCustName;
      this.entid = row.StrExcelPath.substring(row.StrExcelPath.indexOf('/') + 1, row.StrExcelPath.lastIndexOf('/'))
      // console.log('dd', this.entid)
      this.instname = row.StrImpInstName;
      this.StrUserName = row.StrServUsrName;
      this.StrSrvCent = row.StrServCentName;
      this.StrObjName = row.StrCustName;
    },
     //查询关账
    closeHandle(){
        //查询关账日期
        xz.getaccountDate(this.closeQuery).then(res =>{
          // console.log('sdf',res)
            if(res.msg&&res.msg.length>0){
              this.closeDate = res.msg[0].Cfgvalue
              let closeDates = res.msg[0].Cfgvalue
              //关账人员
              if((this.closeAccountType != '1')){
                this.pickerOptions = {
                  disabledDate(time) {
                    let disabledTime = (Date.now()<time.getTime())||(time.getTime() < new Date(closeDates).getTime() + 30 * 24 * 60 * 60 * 1000)
                    return disabledTime
                  }
                }
              }
            }
        })
    },
    //查看详情
    showDetails(row) {
      // console.log('val',val)
      this.$router.push({
        path: "/financialRoster",
        query: {
          custname: (row.StrCustName=='项目收支表社保' || row.StrCustName=='项目收支表费用' || row.StrCustName=='利润表' || row.StrCustName=='项目开票信息表') ? '' : row.StrCustName,
          StrTableId: row.StrTableId,
          bookDate: row.BookMonth,
          belongMonth: row.AttributionMonth
        }
      })
    }
  },
  beforeDestroy() {
    // 在页面销毁后，清除计时器
    this.clear();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.page-import .el-tabs{
  width: 99%;
  background-color: #fff;
}
.page-import .pinkButton {
  padding: 5px 10px;
  line-height: initial;
  border: solid 1px #e6a23c;
  font-size: 12px;
  color: #fff;
  border-radius: 4px;
  background-color: #e6a23c;
}
.page-import .el-dialog .el-dialog__header {
  padding: 0;
}
.page-import .el-step__title {
  font-size: 13px;
  line-height: 24px;
}
.page-import .el-step__icon {
  width: 20px;
  height: 20px;
  font-size: 12px;
}
.page-import .dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
</style>
<style scoped>
.changeServe,.changeError{
  margin-right: 8px;
}
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.file-box {
  position: relative;
}
.top-right {
  display: flex;
  align-items: center;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rIcon {
  font-size: 18px;
  color: #50d4ab;
}
</style>


<style >
.changeError {
  padding: 5px 10px;
  border: solid 1px red;
  font-size: 12px;
  color: red;
  border-radius: 4px;
  background-color: #fff;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .el-dialog .el-dialog__header {
  background: #fff;
}
</style>